import React, { createContext, useContext } from "react";

// Define the type of the function to be passed
type MyFunctionType = (data: string) => void;
type MyObjectType = {
  gstr3b_3_1_1: any;
  gstr3b_3_1: any;
  gstr3b_3_2: any;
  gstr3b_4: any;
  gstr3b_5: any;
  gstr3b_breakup: any;
};

interface MyContextType {
  handleGstrThreeBInvoiceListData: MyFunctionType;
  gstrThreeBInvoiceData: MyObjectType;
  month: string;
}

const initialContextValue: MyContextType = {
  handleGstrThreeBInvoiceListData: (data: string) => {},
  gstrThreeBInvoiceData: {
    gstr3b_3_1: {},
    gstr3b_3_1_1: {},
    gstr3b_3_2: {},
    gstr3b_4: {},
    gstr3b_5: {},
    gstr3b_breakup: {},
  },
  month: "",
};

// Create the context with an initial default value
const MyContext = createContext<MyContextType>(initialContextValue);

// Create a hook to easily consume the context value
const useMyContext: any = () => {
  return useContext(MyContext);
};

export { MyContext, useMyContext };
